import React from "react";
import { Reveal } from "@/lib/motion";
import { ClipboardList, PhoneCall, Target, MessageCircle, LineChart } from "lucide-react";

const items = [
  { icon: ClipboardList, title: "Custom Training Program", desc: "A training plan built personally around your goals, equipment, and schedule." },
  { icon: PhoneCall, title: "Weekly Check-in Call", desc: "A real 30-minute conversation every week to review progress, adjust the plan, and keep momentum going." },
  { icon: Target, title: "Nutrition Guidance", desc: "Personalised calorie and macro targets with practical advice on making it sustainable. No rigid meal plans." },
  { icon: LineChart, title: "App Setup & Tracking Support", desc: "I get you set up with the right tools from day one so tracking never becomes a barrier." },
  { icon: MessageCircle, title: "WhatsApp Access", desc: "Direct line to your coach between sessions. Questions answered, not queued." },
];

export const WhatYouGet = () => {
  return (
    <section
      id="deliverables"
      data-testid="deliverables-section"
      className="relative border-t border-white/10 py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-12 lg:gap-x-20">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="text-xs uppercase tracking-[0.28em] text-white/40">What To Expect</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-syne font-bold tracking-tight text-4xl md:text-5xl leading-[0.98]">
                The full <span className="font-cormorant italic font-light text-white/60">toolkit.</span>
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            {items.map((it, i) => {
              const Icon = it.icon;
              return (
                <Reveal key={it.title} delay={i * 0.06}>
                  <div className="group grid grid-cols-1 md:grid-cols-[auto_1fr] gap-6 md:gap-10 border-t border-white/10 py-9 items-start transition-colors duration-500 hover:border-white/30">
                    <div className="flex items-center gap-6">
                      <Icon size={26} strokeWidth={1.2} className="text-white/70 transition-colors duration-500 group-hover:text-white" />
                    </div>
                    <div className="flex flex-col md:flex-row md:items-baseline md:justify-between gap-2">
                      <h3 className="font-syne text-xl md:text-2xl font-semibold tracking-tight shrink-0 md:w-64">
                        {it.title}
                      </h3>
                      <p className="text-white/45 font-light leading-relaxed max-w-md">{it.desc}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
